module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "repsUserList"
  }, [_c('v-content', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('center', [(_vm.repsLoaded == false) ? _c('img', {
    staticClass: "imgLoader",
    attrs: {
      "src": require("../../shared/assets/images/3dloader.gif")
    }
  }) : _vm._e()]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "float": "left",
      "width": "100% !important",
      "margin-right": "10px !important"
    },
    attrs: {
      "xs2": ""
    }
  }, [_c('div', {
    staticClass: "relative"
  }, [(_vm.search != '') ? _c('a', {
    staticClass: "searchTypeClear",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncClearSearch.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons searchTypeClearText"
  }, [_vm._v("close")])]) : _vm._e(), _vm._v(" "), (_vm.repsLoaded == true && _vm.search != '') ? _c('v-text-field', {
    attrs: {
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    on: {
      "input": _vm.fncFilterUsers
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.repsLoaded == true && _vm.search == '') ? _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "solo": "",
      "single-line": ""
    },
    on: {
      "input": _vm.fncFilterUsers
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }) : _vm._e(), _c('br')], 1)]), _vm._v(" "), (_vm.branchList.length != 0 && _vm.repsLoaded == true && _vm.search == '') ? _c('v-flex', {
    staticStyle: {
      "left": "19%",
      "float": "left",
      "width": "100%",
      "margin-right": "10px !important"
    },
    attrs: {
      "xs2": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.branchList,
      "item-value": "id",
      "item-text": "name",
      "label": "Branch Filter",
      "autocomplete": "",
      "solo": ""
    },
    on: {
      "input": _vm.fncFilterTreeByBranches
    },
    model: {
      value: (_vm.branchFilter),
      callback: function($$v) {
        _vm.branchFilter = $$v
      },
      expression: "branchFilter"
    }
  }), _vm._v(" "), _c('br')], 1) : _vm._e(), _vm._v(" "), (_vm.departmentListSet.length != 0 && _vm.repsLoaded == true && _vm.search == '') ? _c('v-flex', {
    staticStyle: {
      "left": "36.5%",
      "float": "left",
      "width": "100%",
      "margin-right": "10px !important"
    },
    attrs: {
      "xs2": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.departmentListSet,
      "item-value": "id",
      "item-text": "name",
      "label": "Department Filter",
      "autocomplete": "",
      "solo": ""
    },
    on: {
      "input": _vm.fncFilterTreeByDepartments
    },
    model: {
      value: (_vm.departmentFilter),
      callback: function($$v) {
        _vm.departmentFilter = $$v
      },
      expression: "departmentFilter"
    }
  }), _vm._v(" "), _c('br')], 1) : _vm._e(), _vm._v(" "), (_vm.search != '' && _vm.repsLoaded == true) ? _c('v-flex', {
    staticStyle: {
      "left": "19%",
      "float": "left",
      "width": "100%",
      "margin-top": "-4px",
      "margin-left": "8px"
    },
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    staticClass: "elevation-5",
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncClearFilter.apply(null, arguments)
      }
    }
  }, [_vm._v("Clear Filters")]), _vm._v(" "), _c('br')], 1) : _vm._e(), _vm._v(" "), ((_vm.branchFilter != '' || _vm.departmentFilter != '') && _vm.repsLoaded == true) ? _c('v-flex', {
    staticStyle: {
      "left": "55%",
      "float": "left",
      "width": "100%",
      "margin-top": "-4px",
      "margin-left": "8px"
    },
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    staticClass: "elevation-5",
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncClearFilter.apply(null, arguments)
      }
    }
  }, [_vm._v("Clear Filters")]), _vm._v(" "), _c('br')], 1) : _vm._e(), _vm._v(" "), (_vm.repsLoaded == true) ? _c('v-data-table', {
    staticClass: "elevation-1 mainTable",
    attrs: {
      "headers": _vm.headers,
      "id": "userTable",
      "items": _vm.filteredUsers,
      "disable-initial-sort": "",
      "rows-per-page-items": [60]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [(props.expanded == true && (_vm.objAuthorize.branch_active == 0 && _vm.objAuthorize.department_active == 0)) ? _c('td', {
          attrs: {
            "width": "50%"
          },
          on: {
            "click": function($event) {
              props.expanded = !props.expanded
            }
          }
        }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
          staticClass: "material-icons showHide"
        }, [_vm._v("arrow_downward")]) : _vm._e(), _vm._v(_vm._s(props.item.label)), _c('div', {
          domProps: {
            "innerHTML": _vm._s(_vm.fncUserCommunication(props.item))
          }
        })]) : _vm._e(), _vm._v(" "), (props.expanded != true && (_vm.objAuthorize.branch_active == 0 && _vm.objAuthorize.department_active == 0)) ? _c('td', {
          attrs: {
            "width": "50%"
          },
          on: {
            "click": function($event) {
              props.expanded = !props.expanded
            }
          }
        }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
          staticClass: "material-icons showHide"
        }, [_vm._v("arrow_forward")]) : _vm._e(), _vm._v(_vm._s(props.item.label)), _c('div', {
          domProps: {
            "innerHTML": _vm._s(_vm.fncUserCommunication(props.item))
          }
        })]) : _vm._e(), _vm._v(" "), (props.expanded == true && (_vm.objAuthorize.branch_active == 1 && _vm.objAuthorize.department_active == 1)) ? _c('td', {
          attrs: {
            "width": "40%"
          },
          on: {
            "click": function($event) {
              props.expanded = !props.expanded
            }
          }
        }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
          staticClass: "material-icons showHide"
        }, [_vm._v("arrow_downward")]) : _vm._e(), _vm._v(_vm._s(props.item.label)), _c('div', {
          domProps: {
            "innerHTML": _vm._s(_vm.fncUserCommunication(props.item))
          }
        })]) : _vm._e(), _vm._v(" "), (props.expanded != true && (_vm.objAuthorize.branch_active == 1 && _vm.objAuthorize.department_active == 1)) ? _c('td', {
          attrs: {
            "width": "40%"
          },
          on: {
            "click": function($event) {
              props.expanded = !props.expanded
            }
          }
        }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
          staticClass: "material-icons showHide"
        }, [_vm._v("arrow_forward")]) : _vm._e(), _vm._v(_vm._s(props.item.label)), _c('div', {
          domProps: {
            "innerHTML": _vm._s(_vm.fncUserCommunication(props.item))
          }
        })]) : _vm._e(), _vm._v(" "), (props.expanded == true && ((_vm.objAuthorize.branch_active == 1 || _vm.objAuthorize.department_active == 1) && (_vm.objAuthorize.branch_active != _vm.objAuthorize.department_active))) ? _c('td', {
          attrs: {
            "width": "40%"
          },
          on: {
            "click": function($event) {
              props.expanded = !props.expanded
            }
          }
        }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
          staticClass: "material-icons showHide"
        }, [_vm._v("arrow_downward")]) : _vm._e(), _vm._v(_vm._s(props.item.label)), _c('div', {
          domProps: {
            "innerHTML": _vm._s(_vm.fncUserCommunication(props.item))
          }
        })]) : _vm._e(), _vm._v(" "), (props.expanded != true && ((_vm.objAuthorize.branch_active == 1 || _vm.objAuthorize.department_active == 1) && (_vm.objAuthorize.branch_active != _vm.objAuthorize.department_active))) ? _c('td', {
          attrs: {
            "width": "40%"
          },
          on: {
            "click": function($event) {
              props.expanded = !props.expanded
            }
          }
        }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
          staticClass: "material-icons showHide"
        }, [_vm._v("arrow_forward")]) : _vm._e(), _vm._v(_vm._s(props.item.label)), _c('div', {
          domProps: {
            "innerHTML": _vm._s(_vm.fncUserCommunication(props.item))
          }
        })]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.department_active == 1) ? _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [(props.item.department != null && props.item.department != '' && props.item.department != '0') ? _c('v-tooltip', {
          staticStyle: {
            "top": "0px !important"
          },
          attrs: {
            "bottom": ""
          }
        }, [_c('p', {
          staticStyle: {
            "cursor": "pointer",
            "padding-top": "14px",
            "float": "left",
            "display": "block"
          },
          attrs: {
            "slot": "activator"
          },
          slot: "activator"
        }, [_vm._v("  View Departments")]), _vm._v(" "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.fncGetUserDepartment(props.item.department))
          }
        })]) : _c('p', [_c('strong', [_vm._v("N/A")])])], 1) : _vm._e(), _vm._v(" "), _c('td', {
          attrs: {
            "width": "15%"
          }
        }, [_vm._v(_vm._s(props.item.roleName) + " "), _c('small', [_vm._v("{ Level " + _vm._s(props.item.level) + " }")])]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_vm._v(_vm._s(props.item.contactno))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "15%"
          }
        }, [_vm._v(_vm._s(props.item.email))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('v-menu', {
          attrs: {
            "offset-y": ""
          }
        }, [_c('v-toolbar-side-icon', {
          attrs: {
            "slot": "activator"
          },
          slot: "activator"
        }), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncEditUser(props.item)
            }
          }
        }, [_c('v-list-tile-title', [_c('a', [_vm._v("Edit User")])])], 1), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('v-list-tile', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncLinkUsers(props.item.id)
            }
          }
        }, [_c('v-list-tile-title', [_c('a', [_vm._v("Link Users")])])], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('v-list-tile', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncLinkCustomers(props.item.id)
            }
          }
        }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Link Customers")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('EDIT_USER_PRICELISTS') !== -1) ? _c('v-list-tile', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncEditPricelist(props.item.id)
            }
          }
        }, [_c('v-list-tile-title', [_c('a', [_vm._v("Link User Pricelists")])])], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('v-list-tile', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncEditPassword(props.item.id, props.item.email)
            }
          }
        }, [_c('v-list-tile-title', [_c('a', [_vm._v("Update Password")])])], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('HIDE_ADDITIONAL_USER_ACTIONS') == -1) ? _c('v-list-tile', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncEditNotifications(props.item.id)
            }
          }
        }, [_c('v-list-tile-title', [_c('a', [_vm._v("Communication Settings")])])], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('HIDE_ADDITIONAL_USER_ACTIONS') == -1) ? _c('v-list-tile', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncViewUser(props.item.id, props.item.region)
            }
          }
        }, [_c('v-list-tile-title', [_c('a', [_vm._v("User Details")])])], 1) : _vm._e()], 1)], 1)], 1)])]
      }
    }, {
      key: "expand",
      fn: function(props) {
        return [(props.item.branch != '') ? _c('v-data-table', {
          staticClass: "elevation-1 subTable subTable1 minTable",
          attrs: {
            "headers": _vm.headers,
            "items": props.item.branch,
            "hide-actions": "",
            "disable-initial-sort": "",
            "rows-per-page-items": [20, 40, 60, 80, 100]
          },
          scopedSlots: _vm._u([{
            key: "items",
            fn: function(props) {
              return [_c('tr', [(props.expanded == true && (_vm.objAuthorize.branch_active == 0 && _vm.objAuthorize.department_active == 0)) ? _c('td', {
                staticClass: "levelone",
                attrs: {
                  "width": "50%"
                },
                on: {
                  "click": function($event) {
                    props.expanded = !props.expanded
                  }
                }
              }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
                staticClass: "material-icons showHide"
              }, [_vm._v("arrow_downward")]) : _vm._e(), _vm._v(_vm._s(props.item.label)), _c('div', {
                domProps: {
                  "innerHTML": _vm._s(_vm.fncUserCommunication(props.item))
                }
              })]) : _vm._e(), _vm._v(" "), (props.expanded != true && (_vm.objAuthorize.branch_active == 0 && _vm.objAuthorize.department_active == 0)) ? _c('td', {
                staticClass: "levelone",
                attrs: {
                  "width": "50%"
                },
                on: {
                  "click": function($event) {
                    props.expanded = !props.expanded
                  }
                }
              }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
                staticClass: "material-icons showHide"
              }, [_vm._v("arrow_forward")]) : _vm._e(), _vm._v(_vm._s(props.item.label)), _c('div', {
                domProps: {
                  "innerHTML": _vm._s(_vm.fncUserCommunication(props.item))
                }
              })]) : _vm._e(), _vm._v(" "), (props.expanded == true && (_vm.objAuthorize.branch_active == 1 && _vm.objAuthorize.department_active == 1)) ? _c('td', {
                staticClass: "levelone",
                attrs: {
                  "width": "40%"
                },
                on: {
                  "click": function($event) {
                    props.expanded = !props.expanded
                  }
                }
              }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
                staticClass: "material-icons showHide"
              }, [_vm._v("arrow_downward")]) : _vm._e(), _vm._v(_vm._s(props.item.label)), _c('div', {
                domProps: {
                  "innerHTML": _vm._s(_vm.fncUserCommunication(props.item))
                }
              })]) : _vm._e(), _vm._v(" "), (props.expanded != true && (_vm.objAuthorize.branch_active == 1 && _vm.objAuthorize.department_active == 1)) ? _c('td', {
                staticClass: "levelone",
                attrs: {
                  "width": "40%"
                },
                on: {
                  "click": function($event) {
                    props.expanded = !props.expanded
                  }
                }
              }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
                staticClass: "material-icons showHide"
              }, [_vm._v("arrow_forward")]) : _vm._e(), _vm._v(_vm._s(props.item.label)), _c('div', {
                domProps: {
                  "innerHTML": _vm._s(_vm.fncUserCommunication(props.item))
                }
              })]) : _vm._e(), _vm._v(" "), (props.expanded == true && ((_vm.objAuthorize.branch_active == 1 || _vm.objAuthorize.department_active == 1) && (_vm.objAuthorize.branch_active != _vm.objAuthorize.department_active))) ? _c('td', {
                attrs: {
                  "width": "40%"
                },
                on: {
                  "click": function($event) {
                    props.expanded = !props.expanded
                  }
                }
              }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
                staticClass: "material-icons showHide"
              }, [_vm._v("arrow_downward")]) : _vm._e(), _vm._v(_vm._s(props.item.label)), _c('div', {
                domProps: {
                  "innerHTML": _vm._s(_vm.fncUserCommunication(props.item))
                }
              })]) : _vm._e(), _vm._v(" "), (props.expanded != true && ((_vm.objAuthorize.branch_active == 1 || _vm.objAuthorize.department_active == 1) && (_vm.objAuthorize.branch_active != _vm.objAuthorize.department_active))) ? _c('td', {
                attrs: {
                  "width": "40%"
                },
                on: {
                  "click": function($event) {
                    props.expanded = !props.expanded
                  }
                }
              }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
                staticClass: "material-icons showHide"
              }, [_vm._v("arrow_forward")]) : _vm._e(), _vm._v(_vm._s(props.item.label)), _c('div', {
                domProps: {
                  "innerHTML": _vm._s(_vm.fncUserCommunication(props.item))
                }
              })]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.branch_active == 1) ? _c('td', {
                attrs: {
                  "width": "10%"
                }
              }, [_vm._v(_vm._s(_vm.fncGetUserBranch(props.item.branch_id)))]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.department_active == 1) ? _c('td', {
                attrs: {
                  "width": "10%"
                }
              }, [_vm._v("\n                              Department Here\n                            ")]) : _vm._e(), _vm._v(" "), _c('td', {
                attrs: {
                  "width": "15%"
                }
              }, [_vm._v(_vm._s(props.item.roleName) + " "), _c('small', [_vm._v("{ Level " + _vm._s(props.item.level) + " }")])]), _vm._v(" "), _c('td', {
                attrs: {
                  "width": "10%"
                }
              }, [_vm._v(_vm._s(props.item.contactno))]), _vm._v(" "), _c('td', {
                attrs: {
                  "width": "15%"
                }
              }, [_vm._v(_vm._s(props.item.email))]), _vm._v(" "), _c('td', {
                attrs: {
                  "width": "10%"
                }
              }, [_c('v-menu', {
                attrs: {
                  "offset-y": ""
                }
              }, [_c('v-toolbar-side-icon', {
                attrs: {
                  "slot": "activator"
                },
                slot: "activator"
              }), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.fncEditUser(props.item)
                  }
                }
              }, [_c('v-list-tile-title', [_c('a', [_vm._v("Edit User")])])], 1), _vm._v(" "), _c('v-list-tile', {
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.fncLinkUsers(props.item.id)
                  }
                }
              }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Link Users")]) : _vm._e()])], 1), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('v-list-tile', {
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.fncLinkCustomers(props.item.id)
                  }
                }
              }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Link Customers")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('EDIT_USER_PRICELISTS') !== -1) ? _c('v-list-tile', {
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.fncEditPricelist(props.item.id)
                  }
                }
              }, [_c('v-list-tile-title', [_c('a', [_vm._v("Link User Pricelists")])])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.fncEditPassword(props.item.id, props.item.email)
                  }
                }
              }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Update Password")]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile', {
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.fncEditNotifications(props.item.id)
                  }
                }
              }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Communication Settings")]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile', {
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.fncViewUser(props.item.id, props.item.region)
                  }
                }
              }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("User Details")]) : _vm._e()])], 1)], 1)], 1)], 1)])]
            }
          }, {
            key: "expand",
            fn: function(props) {
              return [(props.item.branch != '') ? _c('v-data-table', {
                staticClass: "elevation-1 subTable subTable2 minTable",
                attrs: {
                  "headers": _vm.headers,
                  "items": props.item.branch,
                  "hide-actions": "",
                  "disable-initial-sort": "",
                  "rows-per-page-items": [20, 40, 60, 80, 100]
                },
                scopedSlots: _vm._u([{
                  key: "items",
                  fn: function(props) {
                    return [_c('tr', [(props.expanded == true && (_vm.objAuthorize.branch_active == 0 && _vm.objAuthorize.department_active == 0)) ? _c('td', {
                      staticClass: "leveltwo",
                      attrs: {
                        "width": "50%"
                      },
                      on: {
                        "click": function($event) {
                          props.expanded = !props.expanded
                        }
                      }
                    }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
                      staticClass: "material-icons showHide"
                    }, [_vm._v("arrow_downward")]) : _vm._e(), _vm._v(_vm._s(props.item.label)), _c('div', {
                      domProps: {
                        "innerHTML": _vm._s(_vm.fncUserCommunication(props.item))
                      }
                    })]) : _vm._e(), _vm._v(" "), (props.expanded != true && (_vm.objAuthorize.branch_active == 0 && _vm.objAuthorize.department_active == 0)) ? _c('td', {
                      staticClass: "leveltwo",
                      attrs: {
                        "width": "50%"
                      },
                      on: {
                        "click": function($event) {
                          props.expanded = !props.expanded
                        }
                      }
                    }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
                      staticClass: "material-icons showHide"
                    }, [_vm._v("arrow_forward")]) : _vm._e(), _vm._v(_vm._s(props.item.label)), _c('div', {
                      domProps: {
                        "innerHTML": _vm._s(_vm.fncUserCommunication(props.item))
                      }
                    })]) : _vm._e(), _vm._v(" "), (props.expanded == true && (_vm.objAuthorize.branch_active == 1 && _vm.objAuthorize.department_active == 1)) ? _c('td', {
                      staticClass: "leveltwo",
                      attrs: {
                        "width": "30%"
                      },
                      on: {
                        "click": function($event) {
                          props.expanded = !props.expanded
                        }
                      }
                    }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
                      staticClass: "material-icons showHide"
                    }, [_vm._v("arrow_downward")]) : _vm._e(), _vm._v(_vm._s(props.item.label)), _c('div', {
                      domProps: {
                        "innerHTML": _vm._s(_vm.fncUserCommunication(props.item))
                      }
                    })]) : _vm._e(), _vm._v(" "), (props.expanded != true && (_vm.objAuthorize.branch_active == 1 && _vm.objAuthorize.department_active == 1)) ? _c('td', {
                      staticClass: "leveltwo",
                      attrs: {
                        "width": "30%"
                      },
                      on: {
                        "click": function($event) {
                          props.expanded = !props.expanded
                        }
                      }
                    }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
                      staticClass: "material-icons showHide"
                    }, [_vm._v("arrow_forward")]) : _vm._e(), _vm._v(_vm._s(props.item.label)), _c('div', {
                      domProps: {
                        "innerHTML": _vm._s(_vm.fncUserCommunication(props.item))
                      }
                    })]) : _vm._e(), _vm._v(" "), (props.expanded == true && ((_vm.objAuthorize.branch_active == 1 || _vm.objAuthorize.department_active == 1) && (_vm.objAuthorize.branch_active != _vm.objAuthorize.department_active))) ? _c('td', {
                      attrs: {
                        "width": "40%"
                      },
                      on: {
                        "click": function($event) {
                          props.expanded = !props.expanded
                        }
                      }
                    }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
                      staticClass: "material-icons showHide"
                    }, [_vm._v("arrow_downward")]) : _vm._e(), _vm._v(_vm._s(props.item.label)), _c('div', {
                      domProps: {
                        "innerHTML": _vm._s(_vm.fncUserCommunication(props.item))
                      }
                    })]) : _vm._e(), _vm._v(" "), (props.expanded != true && ((_vm.objAuthorize.branch_active == 1 || _vm.objAuthorize.department_active == 1) && (_vm.objAuthorize.branch_active != _vm.objAuthorize.department_active))) ? _c('td', {
                      attrs: {
                        "width": "40%"
                      },
                      on: {
                        "click": function($event) {
                          props.expanded = !props.expanded
                        }
                      }
                    }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
                      staticClass: "material-icons showHide"
                    }, [_vm._v("arrow_forward")]) : _vm._e(), _vm._v(_vm._s(props.item.label)), _c('div', {
                      domProps: {
                        "innerHTML": _vm._s(_vm.fncUserCommunication(props.item))
                      }
                    })]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.branch_active == 1) ? _c('td', {
                      attrs: {
                        "width": "10%"
                      }
                    }, [_vm._v(_vm._s(_vm.fncGetUserBranch(props.item.branch_id)))]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.department_active == 1) ? _c('td', {
                      attrs: {
                        "width": "10%"
                      }
                    }, [_vm._v(_vm._s(_vm.fncGetUserDepartment(props.item.department)))]) : _vm._e(), _vm._v(" "), _c('td', {
                      attrs: {
                        "width": "15%"
                      }
                    }, [_vm._v(_vm._s(props.item.roleName) + " "), _c('small', [_vm._v("{ Level " + _vm._s(props.item.level) + " }")])]), _vm._v(" "), _c('td', {
                      attrs: {
                        "width": "10%"
                      }
                    }, [_vm._v(_vm._s(props.item.contactno))]), _vm._v(" "), _c('td', {
                      attrs: {
                        "width": "15%"
                      }
                    }, [_vm._v(_vm._s(props.item.email))]), _vm._v(" "), _c('td', {
                      attrs: {
                        "width": "10%"
                      }
                    }, [_c('v-menu', {
                      attrs: {
                        "offset-y": ""
                      }
                    }, [_c('v-toolbar-side-icon', {
                      attrs: {
                        "slot": "activator"
                      },
                      slot: "activator"
                    }), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
                      on: {
                        "click": function($event) {
                          $event.preventDefault();
                          return _vm.fncEditUser(props.item)
                        }
                      }
                    }, [_c('v-list-tile-title', [_c('a', [_vm._v("Edit User")])])], 1), _vm._v(" "), _c('v-list-tile', {
                      on: {
                        "click": function($event) {
                          $event.preventDefault();
                          return _vm.fncLinkUsers(props.item.id)
                        }
                      }
                    }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Link Users")]) : _vm._e()])], 1), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('v-list-tile', {
                      on: {
                        "click": function($event) {
                          $event.preventDefault();
                          return _vm.fncLinkCustomers(props.item.id)
                        }
                      }
                    }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Link Customers")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('EDIT_USER_PRICELISTS') !== -1) ? _c('v-list-tile', {
                      on: {
                        "click": function($event) {
                          $event.preventDefault();
                          return _vm.fncEditPricelist(props.item.id)
                        }
                      }
                    }, [_c('v-list-tile-title', [_c('a', [_vm._v("Link User Pricelists")])])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
                      on: {
                        "click": function($event) {
                          $event.preventDefault();
                          return _vm.fncEditPassword(props.item.id, props.item.email)
                        }
                      }
                    }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Update Password")]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile', {
                      on: {
                        "click": function($event) {
                          $event.preventDefault();
                          return _vm.fncEditNotifications(props.item.id)
                        }
                      }
                    }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Communication Settings")]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile', {
                      on: {
                        "click": function($event) {
                          $event.preventDefault();
                          return _vm.fncViewUser(props.item.id, props.item.region)
                        }
                      }
                    }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("User Details")]) : _vm._e()])], 1)], 1)], 1)], 1)])]
                  }
                }, {
                  key: "expand",
                  fn: function(props) {
                    return [(props.item.branch != '') ? _c('v-data-table', {
                      staticClass: "elevation-1 subTable subTable3 minTable",
                      attrs: {
                        "items": props.item.branch,
                        "hide-actions": "",
                        "disable-initial-sort": "",
                        "rows-per-page-items": [20, 40, 60, 80, 100]
                      },
                      scopedSlots: _vm._u([{
                        key: "items",
                        fn: function(props) {
                          return [_c('tr', [(props.expanded == true && (_vm.objAuthorize.branch_active == 0 && _vm.objAuthorize.department_active == 0)) ? _c('td', {
                            staticClass: "levelthree",
                            attrs: {
                              "width": "50%"
                            },
                            on: {
                              "click": function($event) {
                                props.expanded = !props.expanded
                              }
                            }
                          }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
                            staticClass: "material-icons showHide"
                          }, [_vm._v("arrow_downward")]) : _vm._e(), _vm._v(_vm._s(props.item.label)), _c('div', {
                            domProps: {
                              "innerHTML": _vm._s(_vm.fncUserCommunication(props.item))
                            }
                          })]) : _vm._e(), _vm._v(" "), (props.expanded != true && (_vm.objAuthorize.branch_active == 0 && _vm.objAuthorize.department_active == 0)) ? _c('td', {
                            staticClass: "levelthree",
                            attrs: {
                              "width": "50%"
                            },
                            on: {
                              "click": function($event) {
                                props.expanded = !props.expanded
                              }
                            }
                          }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
                            staticClass: "material-icons showHide"
                          }, [_vm._v("arrow_forward")]) : _vm._e(), _vm._v(_vm._s(props.item.label)), _c('div', {
                            domProps: {
                              "innerHTML": _vm._s(_vm.fncUserCommunication(props.item))
                            }
                          })]) : _vm._e(), _vm._v(" "), (props.expanded == true && (_vm.objAuthorize.branch_active == 1 && _vm.objAuthorize.department_active == 1)) ? _c('td', {
                            staticClass: "levelthree",
                            attrs: {
                              "width": "30%"
                            },
                            on: {
                              "click": function($event) {
                                props.expanded = !props.expanded
                              }
                            }
                          }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
                            staticClass: "material-icons showHide"
                          }, [_vm._v("arrow_downward")]) : _vm._e(), _vm._v(_vm._s(props.item.label)), _c('div', {
                            domProps: {
                              "innerHTML": _vm._s(_vm.fncUserCommunication(props.item))
                            }
                          })]) : _vm._e(), _vm._v(" "), (props.expanded != true && (_vm.objAuthorize.branch_active == 1 && _vm.objAuthorize.department_active == 1)) ? _c('td', {
                            staticClass: "levelthree",
                            attrs: {
                              "width": "30%"
                            },
                            on: {
                              "click": function($event) {
                                props.expanded = !props.expanded
                              }
                            }
                          }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
                            staticClass: "material-icons showHide"
                          }, [_vm._v("arrow_forward")]) : _vm._e(), _vm._v(_vm._s(props.item.label)), _c('div', {
                            domProps: {
                              "innerHTML": _vm._s(_vm.fncUserCommunication(props.item))
                            }
                          })]) : _vm._e(), _vm._v(" "), (props.expanded == true && ((_vm.objAuthorize.branch_active == 1 || _vm.objAuthorize.department_active == 1) && (_vm.objAuthorize.branch_active != _vm.objAuthorize.department_active))) ? _c('td', {
                            attrs: {
                              "width": "40%"
                            },
                            on: {
                              "click": function($event) {
                                props.expanded = !props.expanded
                              }
                            }
                          }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
                            staticClass: "material-icons showHide"
                          }, [_vm._v("arrow_downward")]) : _vm._e(), _vm._v(_vm._s(props.item.label)), _c('div', {
                            domProps: {
                              "innerHTML": _vm._s(_vm.fncUserCommunication(props.item))
                            }
                          })]) : _vm._e(), _vm._v(" "), (props.expanded != true && ((_vm.objAuthorize.branch_active == 1 || _vm.objAuthorize.department_active == 1) && (_vm.objAuthorize.branch_active != _vm.objAuthorize.department_active))) ? _c('td', {
                            attrs: {
                              "width": "40%"
                            },
                            on: {
                              "click": function($event) {
                                props.expanded = !props.expanded
                              }
                            }
                          }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
                            staticClass: "material-icons showHide"
                          }, [_vm._v("arrow_forward")]) : _vm._e(), _vm._v(_vm._s(props.item.label)), _c('div', {
                            domProps: {
                              "innerHTML": _vm._s(_vm.fncUserCommunication(props.item))
                            }
                          })]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.branch_active == 1) ? _c('td', {
                            attrs: {
                              "width": "10%"
                            }
                          }, [_vm._v(_vm._s(_vm.fncGetUserBranch(props.item.branch_id)))]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.department_active == 1) ? _c('td', {
                            attrs: {
                              "width": "10%"
                            }
                          }, [_vm._v(_vm._s(_vm.fncGetUserDepartment(props.item.department)))]) : _vm._e(), _vm._v(" "), _c('td', {
                            attrs: {
                              "width": "15%"
                            }
                          }, [_vm._v(_vm._s(props.item.roleName) + " "), _c('small', [_vm._v("{ Level " + _vm._s(props.item.level) + " }")])]), _vm._v(" "), _c('td', {
                            attrs: {
                              "width": "10%"
                            }
                          }, [_vm._v(_vm._s(props.item.contactno))]), _vm._v(" "), _c('td', {
                            attrs: {
                              "width": "15%"
                            }
                          }, [_vm._v(_vm._s(props.item.email))]), _vm._v(" "), _c('td', {
                            attrs: {
                              "width": "10%"
                            }
                          }, [_c('v-menu', {
                            attrs: {
                              "offset-y": ""
                            }
                          }, [_c('v-toolbar-side-icon', {
                            attrs: {
                              "slot": "activator"
                            },
                            slot: "activator"
                          }), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
                            on: {
                              "click": function($event) {
                                $event.preventDefault();
                                return _vm.fncEditUser(props.item)
                              }
                            }
                          }, [_c('v-list-tile-title', [_c('a', [_vm._v("Edit User")])])], 1), _vm._v(" "), _c('v-list-tile', {
                            on: {
                              "click": function($event) {
                                $event.preventDefault();
                                return _vm.fncLinkUsers(props.item.id)
                              }
                            }
                          }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Link Users")]) : _vm._e()])], 1), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('v-list-tile', {
                            on: {
                              "click": function($event) {
                                $event.preventDefault();
                                return _vm.fncLinkCustomers(props.item.id)
                              }
                            }
                          }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Link Customers")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('EDIT_USER_PRICELISTS') !== -1) ? _c('v-list-tile', {
                            on: {
                              "click": function($event) {
                                $event.preventDefault();
                                return _vm.fncEditPricelist(props.item.id)
                              }
                            }
                          }, [_c('v-list-tile-title', [_c('a', [_vm._v("Link User Pricelists")])])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
                            on: {
                              "click": function($event) {
                                $event.preventDefault();
                                return _vm.fncEditPassword(props.item.id, props.item.email)
                              }
                            }
                          }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Update Password")]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile', {
                            on: {
                              "click": function($event) {
                                $event.preventDefault();
                                return _vm.fncEditNotifications(props.item.id)
                              }
                            }
                          }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Communication Settings")]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile', {
                            on: {
                              "click": function($event) {
                                $event.preventDefault();
                                return _vm.fncViewUser(props.item.id, props.item.region)
                              }
                            }
                          }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("User Details")]) : _vm._e()])], 1)], 1)], 1)], 1)])]
                        }
                      }, {
                        key: "expand",
                        fn: function(props) {
                          return [(props.item.branch != '') ? _c('v-data-table', {
                            staticClass: "elevation-1 subTable subTable4 minTable",
                            attrs: {
                              "items": props.item.branch,
                              "hide-actions": "",
                              "disable-initial-sort": "",
                              "rows-per-page-items": [20, 40, 60, 80, 100]
                            },
                            scopedSlots: _vm._u([{
                              key: "items",
                              fn: function(props) {
                                return [_c('tr', [(props.expanded == true && (_vm.objAuthorize.branch_active == 0 && _vm.objAuthorize.department_active == 0)) ? _c('td', {
                                  staticClass: "levelfour",
                                  attrs: {
                                    "width": "50%"
                                  },
                                  on: {
                                    "click": function($event) {
                                      props.expanded = !props.expanded
                                    }
                                  }
                                }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
                                  staticClass: "material-icons showHide"
                                }, [_vm._v("arrow_downward")]) : _vm._e(), _vm._v(_vm._s(props.item.label)), _c('div', {
                                  domProps: {
                                    "innerHTML": _vm._s(_vm.fncUserCommunication(props.item))
                                  }
                                })]) : _vm._e(), _vm._v(" "), (props.expanded != true && (_vm.objAuthorize.branch_active == 0 && _vm.objAuthorize.department_active == 0)) ? _c('td', {
                                  staticClass: "levelfour",
                                  attrs: {
                                    "width": "50%"
                                  },
                                  on: {
                                    "click": function($event) {
                                      props.expanded = !props.expanded
                                    }
                                  }
                                }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
                                  staticClass: "material-icons showHide"
                                }, [_vm._v("arrow_forward")]) : _vm._e(), _vm._v(_vm._s(props.item.label)), _c('div', {
                                  domProps: {
                                    "innerHTML": _vm._s(_vm.fncUserCommunication(props.item))
                                  }
                                })]) : _vm._e(), _vm._v(" "), (props.expanded == true && (_vm.objAuthorize.branch_active == 1 && _vm.objAuthorize.department_active == 1)) ? _c('td', {
                                  staticClass: "levelfour",
                                  attrs: {
                                    "width": "30%"
                                  },
                                  on: {
                                    "click": function($event) {
                                      props.expanded = !props.expanded
                                    }
                                  }
                                }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
                                  staticClass: "material-icons showHide"
                                }, [_vm._v("arrow_downward")]) : _vm._e(), _vm._v(_vm._s(props.item.label)), _c('div', {
                                  domProps: {
                                    "innerHTML": _vm._s(_vm.fncUserCommunication(props.item))
                                  }
                                })]) : _vm._e(), _vm._v(" "), (props.expanded != true && (_vm.objAuthorize.branch_active == 1 && _vm.objAuthorize.department_active == 1)) ? _c('td', {
                                  staticClass: "levelfour",
                                  attrs: {
                                    "width": "30%"
                                  },
                                  on: {
                                    "click": function($event) {
                                      props.expanded = !props.expanded
                                    }
                                  }
                                }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
                                  staticClass: "material-icons showHide"
                                }, [_vm._v("arrow_forward")]) : _vm._e(), _vm._v(_vm._s(props.item.label)), _c('div', {
                                  domProps: {
                                    "innerHTML": _vm._s(_vm.fncUserCommunication(props.item))
                                  }
                                })]) : _vm._e(), _vm._v(" "), (props.expanded == true && ((_vm.objAuthorize.branch_active == 1 || _vm.objAuthorize.department_active == 1) && (_vm.objAuthorize.branch_active != _vm.objAuthorize.department_active))) ? _c('td', {
                                  attrs: {
                                    "width": "40%"
                                  },
                                  on: {
                                    "click": function($event) {
                                      props.expanded = !props.expanded
                                    }
                                  }
                                }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
                                  staticClass: "material-icons showHide"
                                }, [_vm._v("arrow_downward")]) : _vm._e(), _vm._v(_vm._s(props.item.label)), _c('div', {
                                  domProps: {
                                    "innerHTML": _vm._s(_vm.fncUserCommunication(props.item))
                                  }
                                })]) : _vm._e(), _vm._v(" "), (props.expanded != true && ((_vm.objAuthorize.branch_active == 1 || _vm.objAuthorize.department_active == 1) && (_vm.objAuthorize.branch_active != _vm.objAuthorize.department_active))) ? _c('td', {
                                  attrs: {
                                    "width": "40%"
                                  },
                                  on: {
                                    "click": function($event) {
                                      props.expanded = !props.expanded
                                    }
                                  }
                                }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
                                  staticClass: "material-icons showHide"
                                }, [_vm._v("arrow_forward")]) : _vm._e(), _vm._v(_vm._s(props.item.label)), _c('div', {
                                  domProps: {
                                    "innerHTML": _vm._s(_vm.fncUserCommunication(props.item))
                                  }
                                })]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.branch_active == 1) ? _c('td', {
                                  attrs: {
                                    "width": "10%"
                                  }
                                }, [_vm._v(_vm._s(_vm.fncGetUserBranch(props.item.branch_id)))]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.department_active == 1) ? _c('td', {
                                  attrs: {
                                    "width": "10%"
                                  }
                                }, [_vm._v(_vm._s(_vm.fncGetUserDepartment(props.item.department)))]) : _vm._e(), _vm._v(" "), _c('td', {
                                  attrs: {
                                    "width": "15%"
                                  }
                                }, [_vm._v(_vm._s(props.item.roleName) + " "), _c('small', [_vm._v("{ Level " + _vm._s(props.item.level) + " }")])]), _vm._v(" "), _c('td', {
                                  attrs: {
                                    "width": "10%"
                                  }
                                }, [_vm._v(_vm._s(props.item.contactno))]), _vm._v(" "), _c('td', {
                                  attrs: {
                                    "width": "15%"
                                  }
                                }, [_vm._v(_vm._s(props.item.email))]), _vm._v(" "), _c('td', {
                                  attrs: {
                                    "width": "10%"
                                  }
                                }, [_c('v-menu', {
                                  attrs: {
                                    "offset-y": ""
                                  }
                                }, [_c('v-toolbar-side-icon', {
                                  attrs: {
                                    "slot": "activator"
                                  },
                                  slot: "activator"
                                }), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
                                  on: {
                                    "click": function($event) {
                                      $event.preventDefault();
                                      return _vm.fncEditUser(props.item)
                                    }
                                  }
                                }, [_c('v-list-tile-title', [_c('a', [_vm._v("Edit User")])])], 1), _vm._v(" "), _c('v-list-tile', {
                                  on: {
                                    "click": function($event) {
                                      $event.preventDefault();
                                      return _vm.fncLinkUsers(props.item.id)
                                    }
                                  }
                                }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Link Users")]) : _vm._e()])], 1), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('v-list-tile', {
                                  on: {
                                    "click": function($event) {
                                      $event.preventDefault();
                                      return _vm.fncLinkCustomers(props.item.id)
                                    }
                                  }
                                }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Link Customers")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('EDIT_USER_PRICELISTS') !== -1) ? _c('v-list-tile', {
                                  on: {
                                    "click": function($event) {
                                      $event.preventDefault();
                                      return _vm.fncEditPricelist(props.item.id)
                                    }
                                  }
                                }, [_c('v-list-tile-title', [_c('a', [_vm._v("Link User Pricelists")])])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
                                  on: {
                                    "click": function($event) {
                                      $event.preventDefault();
                                      return _vm.fncEditPassword(props.item.id, props.item.email)
                                    }
                                  }
                                }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Update Password")]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile', {
                                  on: {
                                    "click": function($event) {
                                      $event.preventDefault();
                                      return _vm.fncEditNotifications(props.item.id)
                                    }
                                  }
                                }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Communication Settings")]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile', {
                                  on: {
                                    "click": function($event) {
                                      $event.preventDefault();
                                      return _vm.fncViewUser(props.item.id, props.item.region)
                                    }
                                  }
                                }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("User Details")]) : _vm._e()])], 1)], 1)], 1)], 1)])]
                              }
                            }, {
                              key: "expand",
                              fn: function(props) {
                                return [(props.item.branch != '') ? _c('v-data-table', {
                                  staticClass: "elevation-1 subTable subTable5 minTable",
                                  attrs: {
                                    "items": props.item.branch,
                                    "hide-actions": "",
                                    "disable-initial-sort": "",
                                    "rows-per-page-items": [20, 40, 60, 80, 100]
                                  },
                                  scopedSlots: _vm._u([{
                                    key: "items",
                                    fn: function(props) {
                                      return [_c('tr', [(props.expanded == true && (_vm.objAuthorize.branch_active == 0 && _vm.objAuthorize.department_active == 0)) ? _c('td', {
                                        staticClass: "levelfive",
                                        attrs: {
                                          "width": "50%"
                                        },
                                        on: {
                                          "click": function($event) {
                                            props.expanded = !props.expanded
                                          }
                                        }
                                      }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
                                        staticClass: "material-icons showHide"
                                      }, [_vm._v("arrow_downward")]) : _vm._e(), _vm._v(_vm._s(props.item.label)), _c('div', {
                                        domProps: {
                                          "innerHTML": _vm._s(_vm.fncUserCommunication(props.item))
                                        }
                                      })]) : _vm._e(), _vm._v(" "), (props.expanded != true && (_vm.objAuthorize.branch_active == 0 && _vm.objAuthorize.department_active == 0)) ? _c('td', {
                                        staticClass: "levelfive",
                                        attrs: {
                                          "width": "50%"
                                        },
                                        on: {
                                          "click": function($event) {
                                            props.expanded = !props.expanded
                                          }
                                        }
                                      }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
                                        staticClass: "material-icons showHide"
                                      }, [_vm._v("arrow_forward")]) : _vm._e(), _vm._v(_vm._s(props.item.label)), _c('div', {
                                        domProps: {
                                          "innerHTML": _vm._s(_vm.fncUserCommunication(props.item))
                                        }
                                      })]) : _vm._e(), _vm._v(" "), (props.expanded == true && (_vm.objAuthorize.branch_active == 1 && _vm.objAuthorize.department_active == 1)) ? _c('td', {
                                        staticClass: "levelfive",
                                        attrs: {
                                          "width": "30%"
                                        },
                                        on: {
                                          "click": function($event) {
                                            props.expanded = !props.expanded
                                          }
                                        }
                                      }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
                                        staticClass: "material-icons showHide"
                                      }, [_vm._v("arrow_downward")]) : _vm._e(), _vm._v(_vm._s(props.item.label)), _c('div', {
                                        domProps: {
                                          "innerHTML": _vm._s(_vm.fncUserCommunication(props.item))
                                        }
                                      })]) : _vm._e(), _vm._v(" "), (props.expanded != true && (_vm.objAuthorize.branch_active == 1 && _vm.objAuthorize.department_active == 1)) ? _c('td', {
                                        staticClass: "levelfive",
                                        attrs: {
                                          "width": "30%"
                                        },
                                        on: {
                                          "click": function($event) {
                                            props.expanded = !props.expanded
                                          }
                                        }
                                      }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
                                        staticClass: "material-icons showHide"
                                      }, [_vm._v("arrow_forward")]) : _vm._e(), _vm._v(_vm._s(props.item.label)), _c('div', {
                                        domProps: {
                                          "innerHTML": _vm._s(_vm.fncUserCommunication(props.item))
                                        }
                                      })]) : _vm._e(), _vm._v(" "), (props.expanded == true && ((_vm.objAuthorize.branch_active == 1 || _vm.objAuthorize.department_active == 1) && (_vm.objAuthorize.branch_active != _vm.objAuthorize.department_active))) ? _c('td', {
                                        attrs: {
                                          "width": "40%"
                                        },
                                        on: {
                                          "click": function($event) {
                                            props.expanded = !props.expanded
                                          }
                                        }
                                      }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
                                        staticClass: "material-icons showHide"
                                      }, [_vm._v("arrow_downward")]) : _vm._e(), _vm._v(_vm._s(props.item.label)), _c('div', {
                                        domProps: {
                                          "innerHTML": _vm._s(_vm.fncUserCommunication(props.item))
                                        }
                                      })]) : _vm._e(), _vm._v(" "), (props.expanded != true && ((_vm.objAuthorize.branch_active == 1 || _vm.objAuthorize.department_active == 1) && (_vm.objAuthorize.branch_active != _vm.objAuthorize.department_active))) ? _c('td', {
                                        attrs: {
                                          "width": "40%"
                                        },
                                        on: {
                                          "click": function($event) {
                                            props.expanded = !props.expanded
                                          }
                                        }
                                      }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
                                        staticClass: "material-icons showHide"
                                      }, [_vm._v("arrow_forward")]) : _vm._e(), _vm._v(_vm._s(props.item.label)), _c('div', {
                                        domProps: {
                                          "innerHTML": _vm._s(_vm.fncUserCommunication(props.item))
                                        }
                                      })]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.branch_active == 1) ? _c('td', {
                                        attrs: {
                                          "width": "10%"
                                        }
                                      }, [_vm._v(_vm._s(_vm.fncGetUserBranch(props.item.branch_id)))]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.department_active == 1) ? _c('td', {
                                        attrs: {
                                          "width": "10%"
                                        }
                                      }, [_vm._v(_vm._s(_vm.fncGetUserDepartment(props.item.department)))]) : _vm._e(), _vm._v(" "), _c('td', {
                                        attrs: {
                                          "width": "15%"
                                        }
                                      }, [_vm._v(_vm._s(props.item.roleName) + " "), _c('small', [_vm._v("{ Level " + _vm._s(props.item.level) + " }")])]), _vm._v(" "), _c('td', {
                                        attrs: {
                                          "width": "10%"
                                        }
                                      }, [_vm._v(_vm._s(props.item.contactno))]), _vm._v(" "), _c('td', {
                                        attrs: {
                                          "width": "15%"
                                        }
                                      }, [_vm._v(_vm._s(props.item.email))]), _vm._v(" "), _c('td', {
                                        attrs: {
                                          "width": "10%"
                                        }
                                      }, [_c('v-menu', {
                                        attrs: {
                                          "offset-y": ""
                                        }
                                      }, [_c('v-toolbar-side-icon', {
                                        attrs: {
                                          "slot": "activator"
                                        },
                                        slot: "activator"
                                      }), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
                                        on: {
                                          "click": function($event) {
                                            $event.preventDefault();
                                            return _vm.fncEditUser(props.item)
                                          }
                                        }
                                      }, [_c('v-list-tile-title', [_c('a', [_vm._v("Edit User")])])], 1), _vm._v(" "), _c('v-list-tile', {
                                        on: {
                                          "click": function($event) {
                                            $event.preventDefault();
                                            return _vm.fncLinkUsers(props.item.id)
                                          }
                                        }
                                      }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Link Users")]) : _vm._e()])], 1), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('v-list-tile', {
                                        on: {
                                          "click": function($event) {
                                            $event.preventDefault();
                                            return _vm.fncLinkCustomers(props.item.id)
                                          }
                                        }
                                      }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Link Customers")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('EDIT_USER_PRICELISTS') !== -1) ? _c('v-list-tile', {
                                        on: {
                                          "click": function($event) {
                                            $event.preventDefault();
                                            return _vm.fncEditPricelist(props.item.id)
                                          }
                                        }
                                      }, [_c('v-list-tile-title', [_c('a', [_vm._v("Link User Pricelists")])])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
                                        on: {
                                          "click": function($event) {
                                            $event.preventDefault();
                                            return _vm.fncEditPassword(props.item.id, props.item.email)
                                          }
                                        }
                                      }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Update Password")]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile', {
                                        on: {
                                          "click": function($event) {
                                            $event.preventDefault();
                                            return _vm.fncEditNotifications(props.item.id)
                                          }
                                        }
                                      }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Communication Settings")]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile', {
                                        on: {
                                          "click": function($event) {
                                            $event.preventDefault();
                                            return _vm.fncViewUser(props.item.id, props.item.region)
                                          }
                                        }
                                      }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("User Details")]) : _vm._e()])], 1)], 1)], 1)], 1)])]
                                    }
                                  }], null, true)
                                }, [_vm._v(" "), (props.item.branch != '') ? _c('v-data-table', {
                                  staticClass: "elevation-1 subTable subTable6 minTable",
                                  attrs: {
                                    "items": props.item.branch,
                                    "hide-actions": "",
                                    "disable-initial-sort": "",
                                    "rows-per-page-items": [20, 40, 60, 80, 100]
                                  },
                                  scopedSlots: _vm._u([{
                                    key: "items",
                                    fn: function(props) {
                                      return [_c('tr', [(props.expanded == true && (_vm.objAuthorize.branch_active == 0 && _vm.objAuthorize.department_active == 0)) ? _c('td', {
                                        staticClass: "levelsix",
                                        attrs: {
                                          "width": "50%"
                                        },
                                        on: {
                                          "click": function($event) {
                                            props.expanded = !props.expanded
                                          }
                                        }
                                      }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
                                        staticClass: "material-icons showHide"
                                      }, [_vm._v("arrow_downward")]) : _vm._e(), _vm._v(_vm._s(props.item.label)), _c('div', {
                                        domProps: {
                                          "innerHTML": _vm._s(_vm.fncUserCommunication(props.item))
                                        }
                                      })]) : _vm._e(), _vm._v(" "), (props.expanded != true && (_vm.objAuthorize.branch_active == 0 && _vm.objAuthorize.department_active == 0)) ? _c('td', {
                                        staticClass: "levelsix",
                                        attrs: {
                                          "width": "50%"
                                        },
                                        on: {
                                          "click": function($event) {
                                            props.expanded = !props.expanded
                                          }
                                        }
                                      }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
                                        staticClass: "material-icons showHide"
                                      }, [_vm._v("arrow_forward")]) : _vm._e(), _vm._v(_vm._s(props.item.label)), _c('div', {
                                        domProps: {
                                          "innerHTML": _vm._s(_vm.fncUserCommunication(props.item))
                                        }
                                      })]) : _vm._e(), _vm._v(" "), (props.expanded == true && (_vm.objAuthorize.branch_active == 1 && _vm.objAuthorize.department_active == 1)) ? _c('td', {
                                        staticClass: "levelsix",
                                        attrs: {
                                          "width": "30%"
                                        },
                                        on: {
                                          "click": function($event) {
                                            props.expanded = !props.expanded
                                          }
                                        }
                                      }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
                                        staticClass: "material-icons showHide"
                                      }, [_vm._v("arrow_downward")]) : _vm._e(), _vm._v(_vm._s(props.item.label)), _c('div', {
                                        domProps: {
                                          "innerHTML": _vm._s(_vm.fncUserCommunication(props.item))
                                        }
                                      })]) : _vm._e(), _vm._v(" "), (props.expanded != true && (_vm.objAuthorize.branch_active == 1 && _vm.objAuthorize.department_active == 1)) ? _c('td', {
                                        staticClass: "levelsix",
                                        attrs: {
                                          "width": "30%"
                                        },
                                        on: {
                                          "click": function($event) {
                                            props.expanded = !props.expanded
                                          }
                                        }
                                      }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
                                        staticClass: "material-icons showHide"
                                      }, [_vm._v("arrow_forward")]) : _vm._e(), _vm._v(_vm._s(props.item.label)), _c('div', {
                                        domProps: {
                                          "innerHTML": _vm._s(_vm.fncUserCommunication(props.item))
                                        }
                                      })]) : _vm._e(), _vm._v(" "), (props.expanded == true && ((_vm.objAuthorize.branch_active == 1 || _vm.objAuthorize.department_active == 1) && (_vm.objAuthorize.branch_active != _vm.objAuthorize.department_active))) ? _c('td', {
                                        attrs: {
                                          "width": "40%"
                                        },
                                        on: {
                                          "click": function($event) {
                                            props.expanded = !props.expanded
                                          }
                                        }
                                      }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
                                        staticClass: "material-icons showHide"
                                      }, [_vm._v("arrow_downward")]) : _vm._e(), _vm._v(_vm._s(props.item.label)), _c('div', {
                                        domProps: {
                                          "innerHTML": _vm._s(_vm.fncUserCommunication(props.item))
                                        }
                                      })]) : _vm._e(), _vm._v(" "), (props.expanded != true && ((_vm.objAuthorize.branch_active == 1 || _vm.objAuthorize.department_active == 1) && (_vm.objAuthorize.branch_active != _vm.objAuthorize.department_active))) ? _c('td', {
                                        attrs: {
                                          "width": "40%"
                                        },
                                        on: {
                                          "click": function($event) {
                                            props.expanded = !props.expanded
                                          }
                                        }
                                      }, [(props.item.branch.length > 0 && _vm.search == '') ? _c('i', {
                                        staticClass: "material-icons showHide"
                                      }, [_vm._v("arrow_forward")]) : _vm._e(), _vm._v(_vm._s(props.item.label)), _c('div', {
                                        domProps: {
                                          "innerHTML": _vm._s(_vm.fncUserCommunication(props.item))
                                        }
                                      })]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.branch_active == 1) ? _c('td', {
                                        attrs: {
                                          "width": "10%"
                                        }
                                      }, [_vm._v(_vm._s(_vm.fncGetUserBranch(props.item.branch_id)))]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.department_active == 1) ? _c('td', {
                                        attrs: {
                                          "width": "10%"
                                        }
                                      }, [_vm._v(_vm._s(_vm.fncGetUserDepartment(props.item.department)))]) : _vm._e(), _vm._v(" "), _c('td', {
                                        attrs: {
                                          "width": "15%"
                                        }
                                      }, [_vm._v(_vm._s(props.item.roleName) + " "), _c('small', [_vm._v("{ Level " + _vm._s(props.item.level) + " }")])]), _vm._v(" "), _c('td', {
                                        attrs: {
                                          "width": "10%"
                                        }
                                      }, [_vm._v(_vm._s(props.item.contactno))]), _vm._v(" "), _c('td', {
                                        attrs: {
                                          "width": "15%"
                                        }
                                      }, [_vm._v(_vm._s(props.item.email))]), _vm._v(" "), _c('td', {
                                        attrs: {
                                          "width": "10%"
                                        }
                                      }, [_c('v-menu', {
                                        attrs: {
                                          "offset-y": ""
                                        }
                                      }, [_c('v-toolbar-side-icon', {
                                        attrs: {
                                          "slot": "activator"
                                        },
                                        slot: "activator"
                                      }), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
                                        on: {
                                          "click": function($event) {
                                            $event.preventDefault();
                                            return _vm.fncEditUser(props.item)
                                          }
                                        }
                                      }, [_c('v-list-tile-title', [_c('a', [_vm._v("Edit User")])])], 1), _vm._v(" "), _c('v-list-tile', {
                                        on: {
                                          "click": function($event) {
                                            $event.preventDefault();
                                            return _vm.fncLinkUsers(props.item.id)
                                          }
                                        }
                                      }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Link Users")]) : _vm._e()])], 1), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('v-list-tile', {
                                        on: {
                                          "click": function($event) {
                                            $event.preventDefault();
                                            return _vm.fncLinkCustomers(props.item.id)
                                          }
                                        }
                                      }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Link Customers")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('EDIT_USER_PRICELISTS') !== -1) ? _c('v-list-tile', {
                                        on: {
                                          "click": function($event) {
                                            $event.preventDefault();
                                            return _vm.fncEditPricelist(props.item.id)
                                          }
                                        }
                                      }, [_c('v-list-tile-title', [_c('a', [_vm._v("Link User Pricelists")])])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
                                        on: {
                                          "click": function($event) {
                                            $event.preventDefault();
                                            return _vm.fncEditPassword(props.item.id, props.item.email)
                                          }
                                        }
                                      }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Update Password")]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile', {
                                        on: {
                                          "click": function($event) {
                                            $event.preventDefault();
                                            return _vm.fncEditNotifications(props.item.id)
                                          }
                                        }
                                      }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("Communication Settings")]) : _vm._e()])], 1), _vm._v(" "), _c('v-list-tile', {
                                        on: {
                                          "click": function($event) {
                                            $event.preventDefault();
                                            return _vm.fncViewUser(props.item.id, props.item.region)
                                          }
                                        }
                                      }, [_c('v-list-tile-title', [(_vm.objAuthorize.privileges.indexOf('VIEW_USERS') !== -1) ? _c('a', [_vm._v("User Details")]) : _vm._e()])], 1)], 1)], 1)], 1)])]
                                    }
                                  }], null, true)
                                }) : _vm._e()], 1) : _vm._e()]
                              }
                            }], null, true)
                          }) : _vm._e()]
                        }
                      }], null, true)
                    }) : _vm._e()]
                  }
                }], null, true)
              }) : _vm._e()]
            }
          }], null, true)
        }) : _vm._e()]
      }
    }], null, false, 252667984)
  }) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}